import { deleteApi, get, post } from "../GenericServices";

const PfpService = {
  getServicesList: (queryString) => {
    return get(`pfp_service?${queryString}`);
  },
  serviceData: (id) => {
    return get(`pfp_service/${id}`);
  },
  saveService: (data) => {
    return post("pfp_service", data);
  },
  deleteService: (id) => {
    return deleteApi(`pfp_service/${id}`);
  },
};

export default PfpService;
